/** Neutral pricing appearance from docs/BRAND_GUIDELINES.md. */
export function pricingPalette(isDark) {
  return {
    isDark,
    page: isDark ? '#040404' : '#FFFFFF',
    ink: isDark ? '#FFFFFF' : '#040404',
    inkSoft: isDark ? '#D0D0D0' : '#424242',
    muted: isDark ? '#B3B3B3' : '#616161',
    faint: isDark ? '#A3A3A3' : '#737373',
    rule: isDark ? '#383838' : '#E5E5E5',
    ruleStrong: isDark ? '#8A8A8A' : '#8C8C8C',
    panel: isDark ? '#1C1C1C' : '#F5F5F5',
    cardSolid: isDark ? '#101010' : '#FFFFFF',
    accent: isDark ? '#FFFFFF' : '#040404',
    accentFill: isDark ? '#FFFFFF' : '#040404',
    accentWash: isDark ? '#1C1C1C' : '#F5F5F5',
    accentSoft: isDark ? '#282828' : '#EBEBEB',
    accentRing: isDark ? '#8A8A8A' : '#8C8C8C',
  };
}
